// extracted by mini-css-extract-plugin
export default {"root":"ModalOverlay_root__M83AM"};